// extracted by mini-css-extract-plugin
export default {"header":"styles_header__MIe7P","subtitle":"styles_subtitle__+gUeO","section":"styles_section__Nxrzn"};